// The landing pages show the number CallTrackingMetrics swapped in, while the
// legal pages would fall back to the site number. The number the visitor saw is
// remembered when they follow a legal link, and the legal pages show it instead.
const STORAGE_KEY = 'source_phone_v1';

const LEGAL_PATHS = ['/privacy-policy', '/terms-and-conditions', '/accessibility'];

const normalizePath = (pathname) => pathname.replace(/\/+$/, '') || '/';

export const isLegalPath = (pathname) => LEGAL_PATHS.includes(normalizePath(pathname));

// The tel: links also carry labels ("Call Now"), so the number is read from the href.
const formatPhone = (digits) => {
  const local = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
  return local.length === 10 ? `(${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6)}` : '';
};

export const rememberSourcePhone = () => {
  const anchor = document.querySelector('a[href^="tel:"]');
  const digits = (anchor?.getAttribute('href') || '').replace(/\D/g, '');
  const phone = formatPhone(digits);
  if (!phone) {
    return;
  }

  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ phone, phoneLink: `tel:${digits}` }));
  } catch (error) {
    // no-op
  }
};

export const readSourcePhone = () => {
  try {
    const stored = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
    return stored?.phone && stored?.phoneLink ? stored : null;
  } catch (error) {
    return null;
  }
};

export const onLegalLinkClick = (event) => {
  const link = event.target?.closest?.('a[href]');
  if (!link) {
    return;
  }

  const url = new URL(link.href, window.location.href);
  if (url.origin === window.location.origin && isLegalPath(url.pathname)) {
    rememberSourcePhone();
  }
};
